'use strict';
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function isPrimitive(value) {
    return value == null || (typeof value === "undefined" ? "undefined" : _type_of(value)) !== 'object' && typeof value !== 'function';
}
exports.isPrimitive = isPrimitive;
